import * as React from "react";
const Comment = (props) => (
  <svg
    width={10}
    height={10}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.54302 6.42292L9.5428 6.42286L9.53976 6.43549C9.30964 7.39126 8.5679 7.98678 7.49816 7.98678H5.49669H5.37906L5.28251 8.05396L3.06029 9.60016L3.06026 9.60012L3.05532 9.60368C3.03206 9.62043 3.0137 9.62445 3.00022 9.62495C2.98514 9.6255 2.96706 9.62179 2.94817 9.61114C2.91085 9.5901 2.87684 9.54566 2.87684 9.4772V8.36178V7.98678H2.50184C1.84117 7.98678 1.3179 7.75852 0.962671 7.38716C0.598085 7.00602 0.375 6.45016 0.375 5.74632V2.61546C0.375 1.95931 0.569075 1.43247 0.886914 1.05966C1.20268 0.689281 1.66121 0.446217 2.24086 0.388913C2.33677 0.381206 2.41708 0.375 2.50184 0.375H7.49816C8.15835 0.375 8.68181 0.60295 9.04101 0.978465C9.40164 1.35548 9.625 1.91118 9.625 2.61546V5.74632C9.625 5.99764 9.59818 6.22427 9.54302 6.42292Z"
      stroke="#969BA1"
      strokeWidth={0.75}
    />
  </svg>
);
export default Comment;